exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.adDetailsGridWrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1em;\n}\n\n.expiresAtWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n\n@media  only screen and (min-width: 768px) {\n  .adDetailsGridWrapper {\n    grid-template-columns: 1fr 1fr;\n  }\n\n}\n@media  only screen and (min-width: 985px) {\n\n  .expiresAtWrapper {\n    flex-direction: row;\n  }\n}", ""]);

// exports
